<template>
  <div>
    <div v-if="selectDetailedClassifications.length">
      <div v-for="(pc, index) in selectDetailedClassifications" :key="index">
        <CompetitionDetailsListCard :populatedFeedback="pc" />
      </div>

      <!-- load more -->
      <div class="text-center" v-if="selectDetailedClassifications.length < selectCount">
        <button class="btn btn-outline-primary" @click="loadMore" v-if="!loading">Load More</button>
        <b-skeleton width="100%" height="200px" class="mb-4" v-else />
      </div>
    </div>

    <div class="text-center" v-else>No data to show for current filters...</div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import CompetitionDetailsListCard from './CompetitionDetailsListCard'

const CompetitionDetailsModule = createNamespacedHelpers('competitionDetails')

export default {
  name: 'CompetitionDetailsList',
  components: {
    CompetitionDetailsListCard
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...CompetitionDetailsModule.mapGetters(['selectDetailedClassifications', 'selectCount'])
  },
  methods: {
    ...CompetitionDetailsModule.mapActions(['fetchFeedbackData']),
    async loadMore() {
      this.loading = true
      await this.fetchFeedbackData({ loadMore: true })
      this.loading = false
    }
  }
}
</script>
